/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Selector_Teams_Load_FailedInputs */



/**
* | output |
* | --- |
* | "Teams could not be loaded. Close and reopen this list to try again." |
*
* @param {Selector_Teams_Load_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const selector_teams_load_failed = /** @type {((inputs?: Selector_Teams_Load_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Selector_Teams_Load_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Teams konnten nicht geladen werden. Schließen Sie die Liste und öffnen Sie sie erneut.")
	return /** @type {LocalizedString} */ ("Teams could not be loaded. Close and reopen this list to try again.")
});